'use client';

import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { List, Image } from 'antd';
import Button, { GeneralButtonType } from '../Button';
import Text from '@components/Text';
import { PhotoType } from './index';
import FolderIcon from '@public/images/album/folder-icon.svg';
import style from './index.module.scss';
import { mobileBreakPoint, withFullPath } from '@/utils/utils';
import { useTranslation } from '@/i18n/use-transition.client';
import useWindowSize from '@/utils/useScreenSize';
import withTheme from '@/theme';

const PhotoList = (props: {
    photoList: PhotoType[];
    handleImageClick: (item: PhotoType) => void;
    loadCount?: number;
}) => {
    const { photoList, loadCount = 4, handleImageClick } = props;
    const [loading, setLoading] = useState(false);
    const [showList, setShowList] = useState<PhotoType[]>([]);
    const { t } = useTranslation();
    const isMobile = useWindowSize().width < mobileBreakPoint;

    useEffect(() => {
        setShowList(photoList.slice(0, loadCount));
    }, [loadCount, photoList]);

    const onLoadMore = () => {
        setLoading(true);
        setShowList(photoList.slice(0, showList.length + loadCount));
        setLoading(false);
    };

    const loadMore =
        !loading && showList.length < photoList.length ? (
            <div className='text-center mt-12 h-8 leading-8'>
                <Button
                    data={{
                        setting: {
                            onClick: onLoadMore,
                        },
                    }}
                >
                    <GeneralButtonType label={t('albumLoadMore')} />
                </Button>
            </div>
        ) : null;

    return withTheme(
        <List
            className={style.photoListWarp}
            // loading={initLoading}
            itemLayout='vertical'
            loadMore={loadMore}
            dataSource={showList}
            grid={{ gutter: [24, 40], xl: 4, lg: 3, xs: 1, sm: 1, md: 2, column: 4 }}
            locale={{ emptyText: <div className='text-base-font-color'>No Result Found</div> }}
            renderItem={(item) => {
                const { albumImage, albumCaption, albumDate } = item;
                return (
                    <div
                        className='cursor-pointer'
                        onClick={() => {
                            handleImageClick(item);
                        }}
                    >
                        <List.Item>
                            <div className='flex flex-col'>
                                <div className='relative'>
                                    <Image
                                        className='object-cover rounded-[5px]'
                                        src={withFullPath(albumImage?.src)}
                                        preview={false}
                                        rootClassName='w-full xmd:h-[316px]'
                                        alt=''
                                    />
                                    {/* <FolderIcon className='absolute right-[8px] bottom-[12px]' /> */}
                                </div>
                                <Text
                                    level='subtitle1'
                                    text={moment(albumDate?.value).format('DD/MM/YYYY') || ''}
                                    className='text-base-font-color mt-4'
                                />
                                <Text
                                    level='body1'
                                    text={albumCaption?.value || ''}
                                    className='text-base-font-color font-extrabold text-[26px] '
                                />
                            </div>
                        </List.Item>
                    </div>
                );
            }}
        />,
        {
            token: {
                screenMD: 991,
                screenLG: 1060,
                screenXL: 1360,
            },
        },
    );
};

export default PhotoList;
